import { ICellRendererComp } from 'ag-grid-community';

export class AgentGroupCellRendererComponent implements ICellRendererComp {
    private params: any;
    private eGui: HTMLDivElement;

    init(params: any): void {
        this.params = params;

        this.eGui = document.createElement('div');

        this.eGui.classList.add('d-flex', 'h-100', 'align-items-center', 'ag_container_for_hover');

        const groupData = params.data[params.colDef.field];

        const groupSpan: HTMLSpanElement = document.createElement('span');

        //truncate groupName
        groupSpan.style.textOverflow = 'ellipsis';
        groupSpan.style.overflow = 'hidden';
        groupSpan.style.whiteSpace = 'nowrap';

        const groupName = groupData?.groupName ?? '';
        groupSpan.innerText = groupName;
        this.eGui.appendChild(groupSpan);

        const optionsMenu: HTMLImageElement = document.createElement('img');
        optionsMenu.src = `${_BaseURI}/App_Themes/Standard/Images/CoreTheme/Dashboard/more_dark.svg`;
        optionsMenu.title = 'more options';
        optionsMenu.style.height = '70%';
        optionsMenu.style.width = 'auto';
        optionsMenu.style.cursor = 'pointer';
        optionsMenu.style.right = '5px';
        optionsMenu.classList.add('position-absolute', 'cv-context-menu-icon-hideable', 'l-kebab-menu');
        optionsMenu.addEventListener('click', (e) => {
            params.api['contextMenuFactory'].showMenu(params.node, params.column, groupName, e);
        });

        this.eGui.appendChild(optionsMenu);
    }

    refresh(params: any): boolean {
        return false;
    }

    afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    }

    getGui(): HTMLElement {
        return this.eGui;
    }

}
